import { FormGroup, ValidationErrors } from '@angular/forms';
import { checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';
import { MyElOsservazioniRespPrecRevEntity } from '../../../../models/interfaces/revisione.interface';

/* InfoPath: sum(my:id) != 0 — la riga prototipo di default (my_id = "0") non conta come osservazione */
export const hasOsservazioniRespPrecRev = (rows: MyElOsservazioniRespPrecRevEntity[] | null | undefined): boolean =>
    (rows ?? []).reduce((sum, row) => sum + toNum(row?.my_id), 0) !== 0;

export const conclusioniCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath: string = formPaths.conclusioni,
    suppCondition = true,
    errorStatus?: string
): void => {
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus);
};

export const getConclusioniGroup = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.conclusioni);
};

export const getConclusioniControl = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.conclusioni}.${path}`);
};

export const applyAuxError = (form: FormGroup, targetPath: string, errors: ValidationErrors, errorKey: string): void => {
    const auxGroupErrors = getGroup(form, 'auxErrors');
    const targetControl = getControl(auxGroupErrors, targetPath);

    const targetError = errors?.[errorKey];
    targetControl.setErrors(targetError ? { [targetPath]: targetError } : null);
};
